<script>
  import { layoutMethods, prpMethods, exportMethods, erpFixMessages} from "@/state/helpers";
  import Swal from 'sweetalert2';
  import { getModuleAccess } from '@/router/helper.js'

  /**
   * PRP Items List component
   */
  export default {
    page: {
      title: "PRP Items List"
    },
    components: {
    },
    computed: {
      ...erpFixMessages
    },
    data() {
      return {
        title: "PRP Items",
        searchValue: {
            search: null,
            searchField: null,
            page: 1,
            rows: 10,
            sort: 'id',
            orderDesc: true,
            status: null,
            category: null,
        },
        searchOptions: [
          { text: 'Search All', value: null },
          { text: 'Category Name', value: "name" },
          { text: 'Item Prize', value: "reward" }
        ],
        fields: [
          { key: "action", label: "Action", sortable: false},
          { key: "reward", label: "Item Prize", sortable: true},
          { key: "status", label: "Status", sortable: true},
          { key: "category", label: "Category", sortable: true},
          { key: "image", label: "Image", sortable: false},
          { key: "amount", label: "PRP Amount", sortable: true},
          { key: "type", label: "Type", sortable: true},
          { key: "receive_amount", label: "Receive Amount", sortable: true},
        ],
        totalItems: 0,
        listItems:[],
        sortBy: "value",
        sortDesc: false,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        categoryOption:[{"value": null,"text":"All"}],
        statusOption:[{"value": null,"text":"All"},{"value": 1,"text":"Active"},{"value": 0,"text":"Inactive"}],
        prpItemsModule: {
          access: {
            create: true,
            read: true,
            update: true,
            delete: true
          }
        }
      };
    },
    methods: {
      ...layoutMethods,
      ...prpMethods,
      ...exportMethods,
    isEmpty(val){
      return (val === undefined || val == null || val.length <= 0) ? true : false;
    },
    getAmount(amount, type) {
      
      amount = this.isEmpty(amount) ? 0 : amount;
      
      switch(type)
      {
        case 'logistics':
          return amount + ' pc(s)'; //logistics
        case 'subscription':
          return amount + ' month(s)'; //subscriptions
        case 'coins':
          return amount + ' blvck coin(s)'; //blvckcoins
        default:
          return amount + ' eload(s)'; //eload
      }
    },
      addPrpItem(){
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "PRP Item Form", params: { id: 0}
          }
        );
      },
      refresh(){
       this.onSearch();
      },
      async onSearch(state=''){
        if(state == 'reset'){
          this.searchValue.page = 1;
        }
        console.log(":: search value ::",JSON.stringify(this.searchValue));
        await this.actionPRP({
            action: "items-list",
            body: this.searchValue
        })
        .then((res) => {
          this.totalItems =res["message"]["pageInfo"]["total"] 
          this.listItems = res["message"]["rows"]
          console.log(res);
        }).catch((e)=>{
          console.log("error while getting list",e);
        });
      },
      tableSorting(ctx){//context
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        this.onSearch('reset');
      },
      async getCategoryall(){
        await this.actionPRP({
            action: "all-category",
            body: {}
        })
        .then((res) => {
          for(let r of res["message"]){
            this.categoryOption.push({"value": r["id"],"text":r["name"]});
          }
        }).catch((e)=>{
          console.log("error while getting details",e);
        });
      },
      deleteItem(item){
        if (!this.prpItemsModule.access.delete) {
          Swal.fire(
            "Access Restricted",
            "You are not allowed to delete a PRP Items.",
            "warning"
          );
        } else {
          Swal.fire({
              title: 'Are you sure?',
              text: `Do you really want to delete ${item.reward}? This process cannot be undone.`,
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                this.actionPRP({
                    action: "delete-item",
                    body: {"prp_item_id":item.id}
                })
                .then((res) => {
                  console.log(res);
                  Swal.fire(
                    "Delete Successful!",
                    `${item.reward} has been deleted.`,
                    "success"
                  );
                  this.onSearch();
                }).catch((e)=>{
                  Swal.fire("Delete Failed!", `An Error Occured: ${e}`, "danger");
                  console.log("error while deleting a job",e);
                });
              }else{
                  return;
              }
          })
        }
      },
      async onExport(){
        await this.onSearch("reset");
        if(this.totalItems ==0){
          Swal.fire("Failed!", this.exportNullPrompt, "warning");
          return;
        }
        // var search_value_holder = this.searchValue;
        let params = Object.assign(
          // this.searchValue,
          {
            module: 'prp_items',
            email: JSON.parse(localStorage.getItem('userData')).email,
            dateRange: this.searchValue.dateRange,
            orderDesc: this.searchValue.orderDesc,
            search: this.searchValue.search,
            searchField: this.searchValue.searchField,
            sort: this.searchValue.sort,
            category: this.searchValue.category,
            status: this.searchValue.status,
          });

        
        this.exportReport(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
          console.log("value:",this.searchValue,params)
          // this.searchValue = search_value_holder;
      }
    },
    
    async mounted(){
      this.changeTitle({title: 'PRP Items'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'PRP Items', to: { name: 'PRP Items'} }
        ]
      });
      this.getCategoryall();
      this.onSearch();
      

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Utilities', 'PRP', 'PRP Items')
        .then((access) => this.prpItemsModule.access = access);
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="row mb-3">
                        <div class="col-md-4 col-sm-4">
                            <div class="my-2">
                                <h5 class="card-title text-dark">
                                    <span class="fw-normal ms-lg-2"> {{ totalItems }} </span> Record(s)
                                </h5>
                            </div>
                        </div>
                        <!-- end col record display--> 
                        <div class="col-md-8 col-sm-8">
                            <div class="d-flex justify-content-lg-end mb-lg-3">
                                <a v-if="prpItemsModule.access.create" class="btn btn-primary me-2" @click="addPrpItem">
                                  <i class="uil uil-plus me-1"></i> Add Item
                                </a>
                                <a class="btn btn-secondary"
                                  @click="refresh"
                                    ><feather
                                    type="refresh-ccw"
                                    size="16"
                                    class="icon nav-icon"
                                    ></feather
                                    >&nbsp;&nbsp; Refresh</a
                                >
                            </div>
                        </div>
                        <!-- end col-8 --> 
                        <div class="row">
                          <div class="w-auto mb-2">
                            <div class="d-flex mt-3 mb-3">
                              <div class="me-3">
                                <form class="d-flex" @submit.prevent="onSearch('reset')">
                                  <b-form-group id="input-group-3" label-for="input-3">
                                    <b-form-select class="form-select rounded-0 rounded-start shadow-none w-200px" id="input-3" v-model="searchValue.searchField" :options="searchOptions"></b-form-select>
                                  </b-form-group>
                                  <b-form-group id="input-group-3" class="text-align-right" label-for="input-3">
                                    <template v-slot:description><div class="d-flex justify-content-end">Search for keyword</div></template>
                                    <b-form-input id="input-keyword" v-model="searchValue.search" class="rounded-0" style="width: auto"></b-form-input>
                                  </b-form-group>
                                </form>
                              </div>
                              <div class="me-3">
                                <b-form-group label-for="reward-status" description="Filter by status">
                                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                                    id="reward-status"
                                    v-model="searchValue.status"
                                    :options="statusOption"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                              <div class="me-3">
                                <b-form-group label-for="reward-status" description="Filter by Category">
                                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                                    id="reward-status"
                                    v-model="searchValue.category"
                                    :options="categoryOption"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                              <div class="me-3">
                                <b-form-group label="">
                                  <b-button variant="primary" type="button" @click="onSearch('reset')" class="px-2 me-2">
                                    <i class='bx bx-search bx-fw'></i>
                                    Search
                                  </b-button>
                                  <a href="javascript:void(0);" class="btn btn-primary me-2" @click="onExport">
                                    <i class="uil uil-export me-1"></i>
                                    Export
                                  </a>
                                </b-form-group>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- end search div--> 
                        <div class="table-responsive">
                          <div class="table align-middle table-nowrap">
                            <b-table
                              :items="listItems"
                              :fields="fields"
                              responsive="sm"
                              :current-page="searchValue.page"
                              :sort-by.sync="sortBy"
                              :sort-desc.sync="sortDesc"
                              @sort-changed="tableSorting"
                              class="table-check"
                            >
                              <template #cell(reward)="data">
                                <span class="text-body m-0 text-capitalize">
                                  <router-link :to="{ name: 'PRP Item Form', params: { id : data.item.id }}" 
                                  class="customer-name">
                                    {{ data.item.reward}}
                                  </router-link>
                                </span>
                              </template>
                              <template #cell(status)="data">
                                <span :class="`${data.item.status == 1 ?  'text-success': 'text-danger'}`">
                                  {{ data.item.status == 1? "Active":"Inactive" }}
                                </span>
                              </template>
                              <template #cell(action)="data">
                                  <b-button variant="danger" class="p-1" @click="deleteItem(data.item)"><i class="bx bx-trash bx-xs bx-fw"></i></b-button>
                              </template>
                              <template #cell(image)="data">
                                <img
                                :src="data.item.imageSrc"
                                alt="PRP Item Image"
                                @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')"
                                class="border-end img-fluid border-0 rounded-start img-cover"
                                style="width: 60px;"
                                />
                              </template>
                              <template #cell(category)="data">
                                <span class="text-capitalize">{{ data.item.category }}</span>
                              </template>
                              <template #cell(amount)="data">
                                <span class="text-capitalize">{{ data.item.prp_amount | toCurrency }}</span>
                              </template>
                              <template #cell(type)="data">
                                <span class="text-capitalize">{{ data.item.type }}</span>
                              </template>
                               <template #cell(receive_amount)="data">
                                <span class="text-capitalize">{{ (getAmount(data.item.receive_amount, data.item.type)) }}</span>
                              </template>
                              
                            </b-table>
                          </div>
                        </div>
                        <div class="row g-0 text-center" v-if="totalItems == 0">
                          <span>No data to display.</span>
                        </div>
                        <div class="row" v-if="totalItems > 0">
                          <div class="col">
                            <div class="form-group row pull-left">
                              <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                              <div class="col-sm-6">
                                <b-form-group label-for="display-record">
                                  <b-form-select class="form-select shadow-none w-fit"
                                    id="display-record"
                                    v-model="searchValue.rows"
                                    :options="pageOptions"
                                    @change="onSearch('reset')"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                            </div>
                            <div
                              class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                              "
                            >
                              <b-pagination
                                v-if="totalItems != 0 && totalItems > searchValue.rows"
                                class="pagination-rounded"
                                v-model="searchValue.page"
                                :total-rows="totalItems"
                                @input="onSearch()"
                                :per-page="searchValue.rows"
                              ></b-pagination>
                            </div>
                          </div>
                        </div>
                    </div>
                    <!-- end row -->
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>